const tabs = {
    tabs: document.querySelectorAll('.jsTab') as NodeListOf<HTMLElement>,
    conts: document.querySelectorAll('.jsTabsBody') as NodeListOf<HTMLElement>,

  
    init() {
      this.setTabs();
    },
  
    setTabs() {
      this.tabs.forEach((item, index) => {
        item.addEventListener('click', () => {
          this.tabs.forEach((item, index) => {
            item.classList.remove('activeClass');
            this.conts[index].classList.remove('activeClass');
          });
          item.classList.add('activeClass');
          this.conts[index].classList.add('activeClass');
        });
      });
    },


  };
  
  export default tabs;
  